var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAnchor = function SvgAnchor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m43.966 27.69-6.085 5.82 1.845.536c-2.644 4.346-7.424 6.26-12.868 6.635V18.64h5.049c.42.424 1.003.683 1.65.683a2.326 2.326 0 1 0-1.65-3.964h-5.049v-2.657c2.453-.959 4.207-3.334 4.207-6.125 0-3.622-2.95-6.578-6.583-6.578C20.85 0 17.9 2.956 17.9 6.577c0 2.982 2.008 5.486 4.738 6.287v2.492h-5.583A2.328 2.328 0 0 0 13.082 17a2.325 2.325 0 0 0 2.326 2.324c.643 0 1.225-.259 1.648-.683h5.583v22.026c-5.736-.427-10.743-2.66-13.256-7.369l1.836-.404-5.686-6.2L3 34.718l2.144-.479c3.135 6.867 10.28 12.399 18.35 12.932l1.252 2.538 1.25-2.531c7.675-.515 14.506-5.56 17.885-11.916l2.08.609-1.995-8.182ZM21.108 6.577a3.377 3.377 0 0 1 6.753 0 3.377 3.377 0 1 1-6.754 0Z"
  })));
};

export default SvgAnchor;